package uz.ferro.erp.feature.task.model

enum class TargetType {
    INVOICE
}